import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { Archive } from 'react-bootstrap-icons'
import { CampaignContext } from '../../../../contexts/CampaignContext'

export default observer(function ArchivedCampaignNotice({ isCollapsed }) {
  const { isArchived, campaign, unarchiveCampaign } = useContext(CampaignContext)

  if (!isArchived) return null

  const archivedOn = new Date(campaign.archived_at).toLocaleDateString()

  if (isCollapsed) {
    return (
      <div className='flex justify-center py-2' title={`Archived on ${archivedOn} - read only`}>
        <span className='p-2 rounded-md bg-amber-50 dark:bg-amber-500/10 text-amber-700 dark:text-amber-300'>
          <Archive />
        </span>
      </div>
    )
  }

  return (
    <div className='mx-3 mt-2 p-3 rounded-lg bg-amber-50 dark:bg-amber-500/10 border-1 border-amber-200 dark:border-amber-500/30'>
      <p className='flex items-center gap-2 text-sm font-semibold text-amber-800 dark:text-amber-300'>
        <Archive className='flex-shrink-0' />
        Archived
      </p>
      <p className='mt-1 text-xs text-amber-700 dark:text-amber-400'>
        Read only since {archivedOn}. Changes are disabled.
      </p>
      <button
        type='button'
        className='mt-2 w-full px-3 py-1 rounded-md text-sm bg-rb-green text-white dark:text-rb-dark-mode'
        onClick={unarchiveCampaign}
      >
        Restore campaign
      </button>
    </div>
  )
})
